import { Component } from '@angular/core';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { MonthlyInvoice } from '../../../../../express-tRPC/src/api/monthly_invoices/types';
import { SaveGroupRequest, SUREPARKgroup } from '../../../../../express-tRPC/src/api/surepark/types';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { TennatAccountContactInfo } from '../../../../../express-tRPC/src/api/tenants/types-generic';
import { LotSettings } from '../../../../../express-tRPC/src/api/lot-settings/types';
import { dropdownOption } from '../../types/common';
import { environment } from '../../../environments/environment';
import { AccessCheckResult } from '../../../../../express-tRPC/src/invoice-library-shared/cross-domain-types';
import { Identifier, SUREPARKSubscriber } from '../../../../../express-tRPC/src/shared/types';

const COMPONENT_FEATURE_NAME = 'SUREPARK Merge Tool';

@Component({
  selector: 'app-surepark-merge',
  templateUrl: './surepark-merge.component.html',
  styleUrl: './surepark-merge.component.scss'
})
export class SureparkMergeComponent {

  filename = 'surepark.components.ts';

  version = environment.version;
  activeFile = environment.activeFile;

  activeStep: number = 0;
  isLoading: boolean = false;
  savingTenantGroups: boolean = false;

  syncContactForMatchedGroupOnly: boolean = true;
  updateGroup: string = "UpdateMatchedOnly";
  updateGroupOptions: dropdownOption[] = [
    {
    name: "Update Matched Only",
    code: "UpdateMatchedOnly"
  },
  {
    name: "Update All",
    code: "UpdateAll"
  }];

  sureParkGroups: SUREPARKgroup[] = [];
  filteredSureParkGroups: SUREPARKgroup[] = [];

  missingSureParkGroupMonthlyProfiles: MonthlyInvoice[];

  allMonthlyProfiles: MonthlyInvoice[] = [];
  allMonthlyProfilesCount: number = 0;

  globalGroupName: SUREPARKgroup;
  tenantGroupNameForm!: FormGroup;
  contactGroupNameForm!: FormGroup;

  tenantGroupNameFormSubmitted: boolean = false;
  tenantContactRateFormSubmitted: boolean = false;
  tenantMissingContactRateFormSubmitted: boolean = false;

  isProfileContactsLoading: boolean = false;
  allProfileContacts: TennatAccountContactInfo[] = [];
  allProfileContactsCount: number = 0;

  missingProfileContacts: TennatAccountContactInfo[] = [];
  inCompleteProfileContacts: TennatAccountContactInfo[] = [];

  allSureparkMembers: SUREPARKSubscriber[] = [];

  totalMonthlyProfilesContactFetched: number = 0;
  monthlyProfilesContactFetchedFailed: MonthlyInvoice[] = [];

  profileContactFetchedPercent: number = 0;
  ac = new AbortController();

  loadingSettings: boolean = false;
  locationSettings!: LotSettings;

  SUREPARKSubscribersData: any[] = []
  isSureparkMemberSaving: boolean = false;

  totalSureparkMemberSaved: number = 0;
  sureparkMemberSavedPercent: number = 0;
  sureparkMemberSaveFailed: number = 0;

  today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();

  constructor(
      private trpcService: TrpcService,
      private messageService: MessageService,
      private fb: FormBuilder,
  ) {}

  ngOnInit() {

    this.activeStep = 0;
    this.isLoading = false;
    this.savingTenantGroups = false;

    this.syncContactForMatchedGroupOnly = true;
    this.updateGroup = "UpdateMatchedOnly";

    this.sureParkGroups = [];
    this.filteredSureParkGroups = [];

    this.missingSureParkGroupMonthlyProfiles = [];

    this.allMonthlyProfiles = [];
    this.allMonthlyProfilesCount = 0;

    this.tenantGroupNameFormSubmitted = false;
    this.tenantContactRateFormSubmitted = false;
    this.tenantMissingContactRateFormSubmitted = false;

    this.isProfileContactsLoading = false;
    this.allProfileContacts = [];
    this.allProfileContactsCount = 0;

    this.missingProfileContacts = [];
    this.inCompleteProfileContacts = [];

    this.allSureparkMembers = [];

    this.totalMonthlyProfilesContactFetched = 0;
    this.monthlyProfilesContactFetchedFailed = [];

    this.profileContactFetchedPercent = 0;

    this.loadingSettings = false;

    this.SUREPARKSubscribersData = []
    this.isSureparkMemberSaving = false;

    this.getSettings();

    this.getSureparkGroups();

    this.tenantGroupNameForm = this.fb.group({
      groups: this.fb.array([]),
      incomplete_contacts_rate: this.fb.array([]),
      missing_contacts_rate: this.fb.array([]),
    });

    this.checkAccessToFeature();

  }

  backToPortal(): void {
    location.href = environment.SITE_URL_LOCAL;
  }

  async getSettings() {

      this.loadingSettings = true;

      let locationSettingsAny: any = await this.trpcService.trpc.settings.get.query().catch((error: any) => {
          this.loadingSettings = false;
          this.messageService.add({
            severity: "error",
            detail: error.message,
          });
        });

      this.locationSettings = locationSettingsAny as LotSettings;

      console.log(`Location settings: `, this.locationSettings);

      this.loadingSettings = false;

    }

  get TenantGroupNameFormControlArray() {
      return this.tenantGroupNameForm.get('groups') as FormArray;
  }

  get ContactRateFormControlArray() {
    return this.tenantGroupNameForm.get('incomplete_contacts_rate') as FormArray;
  }

  get MissingContactRateFormControlArray() {
    return this.tenantGroupNameForm.get('missing_contacts_rate') as FormArray;
  }

  getTenantGroupNameFormGroup(index: number): FormGroup {
    return this.TenantGroupNameFormControlArray.controls[index] as FormGroup;
  }

  getContactRateFormGroup(index: number): FormGroup {
    return this.ContactRateFormControlArray.controls[index] as FormGroup;
  }

  getMissingContactRateFormGroup(index: number): FormGroup {
    return this.MissingContactRateFormControlArray.controls[index] as FormGroup;
  }

  /**
   * Update form validation based on selected group type
   **/
  changeTenantGroupNameValidation(): void {

    for (let index = 0; index < this.TenantGroupNameFormControlArray.length; index++) {
      if(this.updateGroup  == 'UpdateAll') {
        (this.tenantGroupNameForm.get('groups') as FormArray)?.controls[index].get('group')?.setValidators([Validators.required]);
      } else {
        (this.tenantGroupNameForm.get('groups') as FormArray)?.controls[index].get('group')?.setValidators([]);;
      }
      (this.tenantGroupNameForm.get('groups') as FormArray)?.controls[index].get('group')?.updateValueAndValidity();
    }
    this.tenantGroupNameForm.updateValueAndValidity();

  }

  async getSureparkGroups() {
    this.isLoading = true;

    let sureParkGroupsResult: any = await this.trpcService.trpc.surepark.getSureparkGroups.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-message'
      });
    });

    if(sureParkGroupsResult) {
      this.sureParkGroups = sureParkGroupsResult;
      await this.loadMonthlyInvoiceProfiles();
    }
    this.isLoading = false;
  }

  async loadMonthlyInvoiceProfiles() {
    let allMonthlyProfilesResult: any = await this.trpcService.trpc.surepark.getAllMonthlyInvoiceProfiles.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-message'
      });
    });

    if(allMonthlyProfilesResult) {
      this.allMonthlyProfiles = allMonthlyProfilesResult;
      this.allMonthlyProfilesCount = allMonthlyProfilesResult.length;
      this.compareMonthlyProfileWithSureparkGroups();
    }
  }

  compareMonthlyProfileWithSureparkGroups() {
      let alreadyAssignedMonthlyProfiles: MonthlyInvoice[] = this.allMonthlyProfiles.filter((monthlyProfil: MonthlyInvoice) => {
        const matchedIndex = this.sureParkGroups.findIndex((sureParkGroup: SUREPARKgroup) => monthlyProfil.groupId === sureParkGroup.id);
        return matchedIndex !== -1;
      });

      this.missingSureParkGroupMonthlyProfiles = this.allMonthlyProfiles.filter((monthlyProfil: MonthlyInvoice) => {
          const matchedIndex = this.sureParkGroups.findIndex((sureParkGroup: SUREPARKgroup) => monthlyProfil.groupId === sureParkGroup.id);

          if(matchedIndex === -1) {
            const matchedIndex = this.sureParkGroups.findIndex((sureParkGroup: SUREPARKgroup) => monthlyProfil.tenant === sureParkGroup.name);

            let preSelectGroup: SUREPARKgroup | null = null;
            if(matchedIndex !== -1) {
              const matchedProfileIndex = alreadyAssignedMonthlyProfiles.findIndex((monthlyProfil: MonthlyInvoice) => monthlyProfil.groupId == this.sureParkGroups[matchedIndex].id);
              if(matchedProfileIndex === -1) {
                const sameGroupProfiles = this.TenantGroupNameFormControlArray.controls.filter((control: any, index: number) => {
                  if(!control.value.group?.id) return false;
                  return control.value.group?.id == this.sureParkGroups[matchedIndex].id;
                });
                console.log(this.sureParkGroups[matchedIndex].name, sameGroupProfiles.length);
                //Check If group is not already assigned to other profiles
                if(!sameGroupProfiles.length) {
                  preSelectGroup = this.sureParkGroups[matchedIndex];
                }
              }
            }
            this.TenantGroupNameFormControlArray.push(this.fb.group({
              group: [preSelectGroup, []],
              suite: [monthlyProfil.suite, [Validators.required]],
              account: [monthlyProfil.account, [Validators.required]],
            }));
          }
          return matchedIndex === -1;
      });

      console.log(this.missingSureParkGroupMonthlyProfiles);
  }

  filterGroup(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.sureParkGroups.length; i++) {
        let group = this.sureParkGroups[i];
        if (group.name.toLowerCase().trim().indexOf(query.toLowerCase().trim()) == 0) {
            filtered.push(group);
        }
    }

    this.filteredSureParkGroups = filtered;
  }

  applyToAll() {
    this.missingSureParkGroupMonthlyProfiles.forEach((monthlyInvoice: MonthlyInvoice, index: number) => {
      const formGroup = this.getTenantGroupNameFormGroup(index);
      formGroup.get('group')?.setValue(this.globalGroupName);
    })
  }

  async saveTenantGroupName(): Promise<void> {
    this.tenantGroupNameFormSubmitted = true;
    this.messageService.clear();

    if(!this.tenantGroupNameForm.valid) {
      this.messageService.add({
        severity: "error",
        detail: "Please select group for all profiles.",
      });
      return;
    }

    let groupsData: SaveGroupRequest[] = [];
    for (let index = 0; index < this.TenantGroupNameFormControlArray.length; index++) {
      const tenantFormGroup = this.getTenantGroupNameFormGroup(index);
      const value = tenantFormGroup.value;
      if(value['group']) {
        groupsData.push({
          group_id: value['group']['id'],
          group_name: value['group']['name'],
          suite: value['suite'],
          account: value['account'],
        });
      }
    }

    if(!groupsData.length) {
      this.activeStep = 1;

      await this.loadProfileContacts();
      await this.loadSureparkMembers();
      return;
    }

    this.savingTenantGroups = true;
    //save groups into tenant RPC and in tenant table
    await this.trpcService.trpc.surepark.saveTenantGroups.mutate(groupsData).then(async (allProfileContactsResult) => {
      this.messageService.add({
        severity: "success",
        detail: "Monthly profiles group updated.",
      });
      this.activeStep = 1;
      this.savingTenantGroups = false;

      await this.loadProfileContacts();
      await this.loadSureparkMembers();

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.savingTenantGroups = false;
    });
  }

  async loadProfileContacts() {
    this.isProfileContactsLoading = true;

    this.allProfileContacts = [];
    this.totalMonthlyProfilesContactFetched = 0;
    this.profileContactFetchedPercent = 0;
    this.monthlyProfilesContactFetchedFailed = [];

    for (const monthlyProfile of this.allMonthlyProfiles) {
      await this.getProfileContacts(monthlyProfile);
    }
    this.isProfileContactsLoading = false;
  }

  async getProfileContacts(monthlyProfile: MonthlyInvoice): Promise<void> {

    await this.trpcService.trpc.surepark.getAllProfileContacts.query({suite: String(monthlyProfile.suite), account: String(monthlyProfile.account), checkExpired: false}).then((allProfileContactsResult) => {
      if(allProfileContactsResult) {
        this.allProfileContacts = this.allProfileContacts.concat(allProfileContactsResult);
      }
      this.totalMonthlyProfilesContactFetched += 1;
      this.profileContactFetchedPercent = Math.round(100 / this.allMonthlyProfiles.length * this.totalMonthlyProfilesContactFetched);

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: "Unable to load contacts of profile ("+monthlyProfile.suite +" - "+monthlyProfile.account+")",
        key: 'profile-contact-error'
      });
      this.monthlyProfilesContactFetchedFailed.push(monthlyProfile);
    });

  }

  async loadSureparkMembers() {
    let sureparkMembersResult: any = await this.trpcService.trpc.surepark.getSureparkGroupsSubscribers.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-message'
      });
    });

    if(sureparkMembersResult) {
      this.allSureparkMembers = sureparkMembersResult;
      this.getMatchingParkproContacts();
    }
  }

  async getMatchingParkproContacts() {

    const fn = 'getMatchingParkproContacts';
    console.log(`${this.filename} ${fn} entering.`);

    this.inCompleteProfileContacts = [];
    this.allProfileContacts.forEach((profileContact: TennatAccountContactInfo, contactIndex: number) => {
      if(profileContact.keycards) {
        const matchedIndex = this.allSureparkMembers.findIndex((member: SUREPARKSubscriber) => {
          if(member.groupId == profileContact.monthly_profile_details.groupId && member.identifiers?.length){
            const matchIndex = member.identifiers.findIndex((identifier: Identifier) => identifier.type == "Hid");
            if(matchIndex !== -1) {
              const [facility_code, keycard] = member.identifiers[matchIndex].identifierNumber?.split("/")
              let isInCompeteContactDetails: boolean = false;
              if(keycard == profileContact.keycards) {
                this.allProfileContacts[contactIndex]['surepark_member_details'] = member;
                this.allProfileContacts[contactIndex].surepark_member_details['missing_details'] = [];

                if(profileContact.facility_code != facility_code) {
                  this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'Facility ('+profileContact.facility_code+' -> '+facility_code+')'});
                  isInCompeteContactDetails = true;
                }

                if(!member.startValidity && profileContact.effectiveDates) {
                  this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'surepark', detail: 'Effective Date ('+profileContact.effectiveDates+' -> )'});
                  isInCompeteContactDetails = true;
                }

                if(member.startValidity) {
                  const startValidityDateObj = new Date(member.startValidity);
                  const startValidityDate = (startValidityDateObj.getUTCMonth()+1)+"/"+startValidityDateObj.getUTCDate()+"/"+startValidityDateObj.getUTCFullYear();

                  if(new Date(profileContact.effectiveDates).getTime() != new Date(startValidityDate).getTime()) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'surepark', detail: 'Effective Date ('+profileContact.effectiveDates+' -> '+startValidityDate+')'});
                    isInCompeteContactDetails = true;
                  }
                }

                if(!member.endValidity && profileContact.terminationDates) {
                  this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'surepark', detail: 'Termination Date ('+profileContact.terminationDates+' -> )'});
                  isInCompeteContactDetails = true;
                }

                if(member.endValidity) {
                  const endValidityDateObj = new Date(member.endValidity.split("T")[0]);
                  const endValidityDate = (endValidityDateObj.getUTCMonth()+1)+"/"+endValidityDateObj.getUTCDate()+"/"+endValidityDateObj.getUTCFullYear();
                  if(new Date(profileContact.terminationDates).getTime() != new Date(endValidityDate).getTime()) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'surepark', detail: 'Termination Date ('+profileContact.terminationDates+' -> '+endValidityDate+')'});
                    isInCompeteContactDetails = true;
                  }
                }

                const identMatchIndex = member.identifiers.findIndex((identifier: Identifier) => identifier.type == "PlateNumber");
                if(identMatchIndex !== -1) {
                  if(profileContact.plate != member.identifiers[identMatchIndex].identifierNumber) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'License plate ('+member.identifiers[identMatchIndex].identifierNumber+' -> '+profileContact.plate+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.year != member.identifiers[identMatchIndex].year) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'Year ('+member.identifiers[identMatchIndex].year+' -> '+profileContact.year+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.model != member.identifiers[identMatchIndex].model) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'Model ('+member.identifiers[identMatchIndex].model+' -> '+profileContact.model+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.make != member.identifiers[identMatchIndex].make) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail:'Make ('+member.identifiers[identMatchIndex].make+' -> '+profileContact.make+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.color != member.identifiers[identMatchIndex].color) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail:'Color ('+member.identifiers[identMatchIndex].color+' -> '+profileContact.color+')'});
                    isInCompeteContactDetails = true;
                  }
                } else if(identMatchIndex === -1){
                  if(profileContact.plate) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail:'License plate ('+profileContact.plate+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.year) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail:'Year ('+profileContact.year+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.model) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail:'Model ('+profileContact.model+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.make) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'Make ('+profileContact.make+')'});
                    isInCompeteContactDetails = true;
                  }
                  if(profileContact.color) {
                    this.allProfileContacts[contactIndex].surepark_member_details['missing_details'].push({type: 'parkpro', detail: 'Color ('+profileContact.color+')' });
                    isInCompeteContactDetails = true;
                  }
                }
                this.allProfileContacts[contactIndex]['surepark_member_details']['is_keycard_match'] = isInCompeteContactDetails ? "keycard not matched" : "keycard already matched";
                return true;
              }
            }
          }
          return false;
        });

        if(matchedIndex !== -1) {
            //Check rate are correct
            const matchedRateID = this.locationSettings.ratesReport.approved?.findIndex((rate: any) => rate.sureparkID == profileContact['surepark_member_details']['rateId']);
            let rate = '';
            if(matchedRateID !== -1) {
              rate = this.locationSettings.ratesReport.approved[matchedRateID]['sureparkID'];
            }

            this.ContactRateFormControlArray.push(this.fb.group({
              rate: [rate , [Validators.required]],
              suite: [profileContact.monthly_profile_details.suite, [Validators.required]],
              account: [profileContact.monthly_profile_details.account, [Validators.required]],
              keycard: [profileContact.keycards, [Validators.required]],
            }));

            if(this.syncContactForMatchedGroupOnly) {
              const tenantProfilesWithGroupSelected = this.TenantGroupNameFormControlArray.controls.filter((control: any, index: number) => {
                return control.value.group?.id;
              });
              const matchedWithGroup = tenantProfilesWithGroupSelected.findIndex((control: any) =>
                control.value.group.id == profileContact.monthly_profile_details.groupId &&
                control.value.suite == profileContact.monthly_profile_details.suite &&
                control.value.account == profileContact.monthly_profile_details.account
              );
              if(matchedWithGroup !== -1) {
                this.inCompleteProfileContacts.push(profileContact);
              }
            } else {
              this.inCompleteProfileContacts.push(profileContact)
            }

        }
      }
    });

    //Check If there is multiple contacts exist with same facility code and keycard
    this.inCompleteProfileContacts.forEach((inCompleteProfileContact: TennatAccountContactInfo, index:number) => {
      const matchedContacts = this.allProfileContacts.filter((profileContact: TennatAccountContactInfo) =>
        inCompleteProfileContact?.surepark_member_details &&
        inCompleteProfileContact.facility_code == profileContact.facility_code &&
        inCompleteProfileContact.keycards == profileContact.keycards
      );
      if(matchedContacts.length > 1) {
        //If multiple contacts exist then we will display warning
        this.inCompleteProfileContacts[index]['surepark_member_details']['multiple'] = true;
        this.inCompleteProfileContacts[index]['surepark_member_details']['accounts'] = matchedContacts.map((contc: TennatAccountContactInfo) => contc.monthly_profile_details.suite + " - "+contc.monthly_profile_details.account);
      }
    });

    this.missingProfileContacts = this.allProfileContacts.filter((profileContact: TennatAccountContactInfo) => {
      const matchedIndex = this.allSureparkMembers.findIndex((member: SUREPARKSubscriber) => {
        if(member.groupId == profileContact.monthly_profile_details.groupId && member.identifiers?.length){
          if(member.identifiers.length) {
            const matchIndex = member.identifiers.findIndex((identifier: Identifier) => identifier.type == "Hid");
            if(matchIndex !== -1) {
              const [facility_code, keycard] = member.identifiers[matchIndex].identifierNumber?.split("/")
              return keycard == profileContact.keycards;
            }
          }
        }
        return false;
      });

      //If contact is not exist in surepark then
      // check if parkpro contact is active by checking
      // facility code and key card added and effective date is in past and termination date is in future,
      // if this conditions are met then we will create new member on surepark side.
      if(matchedIndex === -1) {
        if(profileContact.keycards && profileContact.effectiveDates && profileContact.terminationDates) {
          const isActiveContact = (this.today >= new Date(profileContact.effectiveDates).getTime() && this.today < new Date(profileContact.terminationDates).getTime());
          if(isActiveContact) {
            if(this.syncContactForMatchedGroupOnly) {
              const tenantProfilesWithGroupSelected = this.TenantGroupNameFormControlArray.controls.filter((control: any, index: number) => {
                return control.value.group?.id;
              });
              const matchedWithGroup = tenantProfilesWithGroupSelected.findIndex((control: any) =>
                control.value.group.id == profileContact.monthly_profile_details.groupId &&
                control.value.suite == profileContact.monthly_profile_details.suite &&
                control.value.account == profileContact.monthly_profile_details.account
              );
              return matchedWithGroup !== -1;
            } else {
              return true;
            }
          }
        }
      }
      return false;
    });

    //Check If there is multiple contacts exist with same facility code and keycard
    this.missingProfileContacts.forEach((missingProfileContact: TennatAccountContactInfo, index:number) => {
      const matchedContacts = this.allProfileContacts.filter((profileContact: TennatAccountContactInfo) =>
        missingProfileContact.facility_code == profileContact.facility_code &&
        missingProfileContact.keycards == profileContact.keycards
      );

      const matchedRateID = this.locationSettings.ratesReport.approved?.findIndex((rate: any) => rate.parkproCode == missingProfileContact['rate']);
      let rate = '';
      if(matchedRateID !== -1) {
        rate = this.locationSettings.ratesReport.approved[matchedRateID]['sureparkID'];
      }

      this.MissingContactRateFormControlArray.push(this.fb.group({
        rate: [rate , [Validators.required]],
        suite: [missingProfileContact.monthly_profile_details.suite, [Validators.required]],
        account: [missingProfileContact.monthly_profile_details.account, [Validators.required]],
        keycard: [missingProfileContact.keycards, [Validators.required]],
        facility_code: [missingProfileContact.facility_code, []],
      }));

      if(matchedContacts.length > 1) {
        //If multiple contacts exist then we will display warning
        this.missingProfileContacts[index]['surepark_member_details'] = { multiple: true, accounts: matchedContacts.map((contc: TennatAccountContactInfo) => contc.monthly_profile_details.suite + " - "+contc.monthly_profile_details.account) };
      }
    });

  }

  filterSureparkMissingDetails(data: any[]) {
    return data?.filter((d: any) => d.type == "surepark") || []
  }

  filterParkproMissingDetails(data: any[]) {
    return data?.filter((d: any) => d.type == "parkpro") || []
  }

  async syncContactsAutomatic(): Promise<void> {

    this.tenantContactRateFormSubmitted = true;
    this.messageService.clear();
    if(!this.tenantGroupNameForm.valid) {
      this.messageService.add({
        severity: "error",
        detail: "Please select rate for all contacts.",
      });
      return;
    }

    this.SUREPARKSubscribersData = [];

    this.inCompleteProfileContacts.forEach((profileContact: TennatAccountContactInfo) => {
      if(!profileContact.surepark_member_details?.multiple && profileContact.surepark_member_details?.is_keycard_match == "keycard not matched") {

        if(this.filterSureparkMissingDetails(profileContact.surepark_member_details?.missing_details)?.length) {
          let SaveSUREPARKSubscriberRequest: SUREPARKSubscriber = Object.assign({}, profileContact.surepark_member_details as SUREPARKSubscriber);
          SaveSUREPARKSubscriberRequest.startValidity = profileContact.effectiveDates;
          SaveSUREPARKSubscriberRequest.endValidity = profileContact.terminationDates;

          if(SaveSUREPARKSubscriberRequest.identifiers?.length) {

              if(profileContact.facility_code && profileContact.keycards && profileContact.effectiveDates && profileContact.terminationDates) {
                //Set Surepark subscriber as if parkpro contact facility code and key card added and effective date is in past and termination date is in future,
                SaveSUREPARKSubscriberRequest.active = (this.today > new Date(profileContact.effectiveDates).getTime() && this.today < new Date(profileContact.terminationDates).getTime())
              }

              const matchingRateFormValueIndex = this.tenantGroupNameForm.value['incomplete_contacts_rate']?.findIndex((rateValue: any) =>
                rateValue['suite'] == profileContact['monthly_profile_details']['suite'] &&
                rateValue['account'] == profileContact['monthly_profile_details']['account'] &&
                rateValue['keycard'] == profileContact.keycards
              );
              SaveSUREPARKSubscriberRequest['rateId'] = this.tenantGroupNameForm.value['incomplete_contacts_rate'][matchingRateFormValueIndex]['rate'];
          }

          this.SUREPARKSubscribersData.push({ type: 'surepark', request: SaveSUREPARKSubscriberRequest});

        }

        if(this.filterParkproMissingDetails(profileContact.surepark_member_details?.missing_details)?.length) {
          let SavePARKPROContactRequest: TennatAccountContactInfo = Object.assign({}, profileContact);

          if(SavePARKPROContactRequest.surepark_member_details.identifiers?.length) {

            let keycardIdentiFiersIndex = SavePARKPROContactRequest.surepark_member_details.identifiers.findIndex((identifier: Identifier) => identifier.type == "Hid");
            SavePARKPROContactRequest.facility_code = '';
            if(keycardIdentiFiersIndex !== -1) {
              const [facility_code, keycard] = SavePARKPROContactRequest.surepark_member_details.identifiers[keycardIdentiFiersIndex].identifierNumber?.split("/")
              SavePARKPROContactRequest.facility_code =  facility_code;
            }

            SavePARKPROContactRequest.plate = '';
            SavePARKPROContactRequest.make = '';
            SavePARKPROContactRequest.model = '';
            SavePARKPROContactRequest.year = '';
            SavePARKPROContactRequest.color = '';

            let plateNumberidentiFiersIndex = SavePARKPROContactRequest.surepark_member_details.identifiers.findIndex((identifier: Identifier) => identifier.type == "PlateNumber");

            if(plateNumberidentiFiersIndex !== -1) {

              //License plate data exist on surepark subscriber so lets update iicense data in parkpro contact
              SavePARKPROContactRequest.plate = SavePARKPROContactRequest.surepark_member_details.identifiers[plateNumberidentiFiersIndex]['identifierNumber'];
              SavePARKPROContactRequest.make = SavePARKPROContactRequest.surepark_member_details.identifiers[plateNumberidentiFiersIndex]['make'];
              SavePARKPROContactRequest.model = SavePARKPROContactRequest.surepark_member_details.identifiers[plateNumberidentiFiersIndex]['model'];
              SavePARKPROContactRequest.year = SavePARKPROContactRequest.surepark_member_details.identifiers[plateNumberidentiFiersIndex]['year'];
              SavePARKPROContactRequest.color = SavePARKPROContactRequest.surepark_member_details.identifiers[plateNumberidentiFiersIndex]['color'];

            }
          }

          this.SUREPARKSubscribersData.push({ type: 'parkpro', request: SavePARKPROContactRequest});
        }

      }
    })

    console.log(this.SUREPARKSubscribersData);

    if(!this.SUREPARKSubscribersData?.length) {
      this.activeStep = 2;
      return;
    }

    this.isSureparkMemberSaving = true;

    this.totalSureparkMemberSaved = 0;
    this.sureparkMemberSavedPercent = 0;
    this.sureparkMemberSaveFailed = 0;

    for (const SaveContactRequest of this.SUREPARKSubscribersData) {
      if(SaveContactRequest.type == "surepark") {
        await this.saveSureparkMember(SaveContactRequest.request);
      } else if(SaveContactRequest.type == "parkpro") {
        await this.saveParkproContact(SaveContactRequest.request);
      }
    }

    this.messageService.add({
      severity: "success",
      detail: "Surepark members updated.",
    });
    setTimeout(() => {
      this.isSureparkMemberSaving = false;
      this.activeStep = 2;
    }, 3000);
  }

  async saveSureparkMember(SUREPARKSubscriber: SUREPARKSubscriber) {
    await this.trpcService.trpc.surepark.saveSureparkGroupsSubscriber.mutate(SUREPARKSubscriber).then((saveSUREPARKSubscriberResult) => {

      this.totalSureparkMemberSaved += 1;
      this.sureparkMemberSavedPercent = Math.round(100 / this.SUREPARKSubscribersData.length * this.totalSureparkMemberSaved);

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'surepark-subscriber-error'
      });
      this.sureparkMemberSaveFailed += 1;
    });
  }

  async saveParkproContact(SUREPARKSubscriber: TennatAccountContactInfo) {
    await this.trpcService.trpc.surepark.saveTenantContact.mutate(SUREPARKSubscriber).then((saveSUREPARKSubscriberResult) => {

      this.totalSureparkMemberSaved += 1;
      this.sureparkMemberSavedPercent = Math.round(100 / this.SUREPARKSubscribersData.length * this.totalSureparkMemberSaved);

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'surepark-subscriber-error'
      });
      this.sureparkMemberSaveFailed += 1;
    });
  }

  async syncMissingContacts() {

    this.tenantMissingContactRateFormSubmitted = true;
    this.messageService.clear();
    if(!this.tenantGroupNameForm.valid) {
      this.messageService.add({
        severity: "error",
        detail: "Please select rate for all contacts.",
      });
      return;
    }

    this.SUREPARKSubscribersData = [];

    this.missingProfileContacts.forEach((profileContact: TennatAccountContactInfo) => {
      if(!profileContact.surepark_member_details?.multiple) {

        const matchingRateFormValueIndex = this.tenantGroupNameForm.value['missing_contacts_rate']?.findIndex((rateValue: any) =>
          rateValue['suite'] == profileContact['monthly_profile_details']['suite'] &&
          rateValue['account'] == profileContact['monthly_profile_details']['account'] &&
          rateValue['keycard'] == profileContact.keycards
        );
        if(matchingRateFormValueIndex !== -1) {
          const facility_code = this.tenantGroupNameForm.value['missing_contacts_rate'][matchingRateFormValueIndex]['facility_code'];

          if(facility_code) {
            const [firstName, lastName] = profileContact.contactName.split(" ");
            const [eMonth, eDate, eYear] = profileContact.effectiveDates.split("/");
            const [tMonth, tDate, tYear] = profileContact.terminationDates.split("/");
            const startValidity = eYear+"-"+eMonth+"-"+eDate;
            const endValidity = tYear+"-"+tMonth+"-"+tDate;

            let SaveSUREPARKSubscriberRequest: SUREPARKSubscriber = {
              active: true,
              apbCorrect: false,
              comments: profileContact.monthly_profile_details.suite+"-"+profileContact.monthly_profile_details.account,
              coupons: [],
              email: profileContact.emails || null,
              endValidity: endValidity, //Format: 2025-12-25
              firstName: firstName,
              groupId: profileContact.monthly_profile_details.groupId,
              id: "00000000-0000-0000-0000-000000000000",
              rateId: "",
              identifiers: [],
              lastName: lastName,
              present: false,
              startValidity: startValidity, //Format: 2025-12-25
              status: 0,
              telephone: profileContact.phones || null,
              type: "Subscriber",
              validations: []
            };

            SaveSUREPARKSubscriberRequest['rateId'] = this.tenantGroupNameForm.value['missing_contacts_rate'][matchingRateFormValueIndex]['rate'];

            let identifiers: Identifier[] = [];
            identifiers.push({
              active: true,
              id: "00000000-0000-0000-0000-000000000000",
              customerId: "00000000-0000-0000-0000-000000000000",
              identifierNumber: facility_code+"/"+profileContact.keycards,
              base24IdentifierData: "",
              color: "",
              make: "",
              model: "",
              year: "",
              type: "Hid",
            });

            if(profileContact.plate) {
              identifiers.push({
                active: true,
                id: "00000000-0000-0000-0000-000000000000",
                customerId: "00000000-0000-0000-0000-000000000000",
                identifierNumber: profileContact.plate,
                base24IdentifierData: "",
                color: profileContact.color,
                make: profileContact.make,
                model: profileContact.model,
                year: profileContact.year,
                type: "PlateNumber"
              });
            }
            SaveSUREPARKSubscriberRequest.identifiers = identifiers;
            this.SUREPARKSubscribersData.push(SaveSUREPARKSubscriberRequest);
          }

        }
      }
    });

    this.isSureparkMemberSaving = true;

    this.totalSureparkMemberSaved = 0;
    this.sureparkMemberSavedPercent = 0;
    this.sureparkMemberSaveFailed = 0;

    for (const SUREPARKSubscriber of this.SUREPARKSubscribersData) {
      await this.saveSureparkMember(SUREPARKSubscriber);
    }

    this.messageService.add({
      severity: "success",
      detail: "Surepark members created.",
    });
    setTimeout(() => {
      this.isSureparkMemberSaving = false;
      this.activeStep = 0;
      this.sureParkGroups = [];
      this.allMonthlyProfiles = [];
      this.ngOnInit();
    }, 3000);

  }

  /**
   * This function will return count of matching value with specific property
   * @param value string to match
   * @returns string
   */
  getGroupCount(value: string): string {
    return this.inCompleteProfileContacts.filter((contact: TennatAccountContactInfo) => contact.surepark_member_details.is_keycard_match == value).length.toString();
  }

  checkAccessToFeature() {
    this.trpcService.trpc.lots.checkAccessToFeature.mutate({
      feature: COMPONENT_FEATURE_NAME
    }).then((response: AccessCheckResult) => {

      if(response.result === 'denied') {
        this.messageService.add({
          severity: "error",
          detail: 'No access to ' + COMPONENT_FEATURE_NAME + ' feature',
          key: 'general-message',
          sticky: true
        });
      }

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: 'Unable to check access to ' + COMPONENT_FEATURE_NAME + ' feature.',
        key: 'general-message',
        sticky: true
      });

    });
  }

}
